import React, { Component } from "react";
import {
  Card,
  FlatButton,
  CardTitle,
  Dialog,
  TextField,
  IconButton,
} from "material-ui";
import searchIcon from "../../images/search_icon.png";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export default class AddPayrollCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      company: this.props.company,
      toastOpen: false,
      responseMsg: "",
      address: "",
      companyIdErrorText: "",
      companyNameErrorText: "",
    };
  }

  componentWillReceiveProps(props) {
    if (props.company && Object.keys(props.company._id).length !== 0) {
      this.setCurrentCompany(props.company);
    } else if (props.open) {
      this.showAddCompany(props.open, props.company);
    }
  }

  setCurrentCompany = (company) => {
    this.setState({ company: company, open: true });
  };

  showAddCompany = (open, company) => {
    this.setState({ open: open, company: company });
  };

  handleChange = (address) => {
    let { company } = this.state;
    company.address = address;
    this.setState({ company: company });
  };

  handleSelect = (address) => {
    let { company } = this.state;
    company.address = address;
    this.setState({ company: company });
  };

  notifyFormError(data, msg) {
    console.error("Form error:", data);
    alert(msg);
  }

  addCompany = () => {
    let { company } = this.state;
    var me = this;
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;

    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }
    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
      employees: [],
    };

    let url = `/api/payroll/addCompany`;
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Company already exist.") {
          this.notifyFormError(res, "Company is already exist.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false });
        me.props.closeAddCompanyPopup();
      }
    });
  };

  updateCompany = () => {
    let { company } = this.state;
    let me = this;
    console.log("this.props---11-----", this.props);
    let companyId = company.companyId;
    let companyName = company.company;
    let contactNumber = company.contactNumber;
    let address = company.address;
    let checkValue = this.checkValidation();
    if (checkValue) {
      return;
    }

    let body = {
      companyId: companyId,
      companyName: companyName,
      contactNumber: contactNumber,
      address: address,
      id: company._id,
    };
    let url = `/api/payroll/editCompany`;
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };
    fetch(url, options).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        if (res.message == "Company already exist.") {
          this.notifyFormError(res, "Company is already exist.");
        } else {
          this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
        }
      } else {
        this.notifyFormError(res, "Internal server error.");
        this.setState({ open: false }, () => me.props.closeAddCompanyPopup());
      }
    });
  };

  closeCompanyModal = () => {
    var me = this;
    this.setState(
      { open: false, companyIdErrorText: "", companyNameErrorText: "" },
      () => me.props.closeAddCompanyPopup(),
    );
  };

  onChangeValue = (key, value) => {
    let { company } = this.state;
    if (key == "companyId") {
      company.companyId = value;
    } else if (key == "company") {
      company.company = value;
    } else if (key == "contactNumber") {
      company.contactNumber = value;
    } else if (key == "address") {
      company.address = value;
    }
    this.setState({
      company: company,
      companyIdErrorText: "",
      companyNameErrorText: "",
    });
  };

  checkValidation() {
    let { company } = this.state;
    if (company.companyId == "" || company.companyId == null) {
      //alert('Please enter clientId');
      this.setState({ companyIdErrorText: "Please enter clientId" });

      return true;
    } else if (company.company == "" || company.company == null) {
      this.setState({ companyNameErrorText: "Please enter company name" });
      return true;
    } else {
      return false;
    }
  }

  render() {
    let { open, company } = this.state;
    return (
      <div>
        <Dialog open={open} style={{ zIndex: "9999999" }}>
          <Card className="addCompanyHeader">
            {company._id != "" ? (
              <CardTitle title="Update Company" />
            ) : (
              <CardTitle title="Add Company" />
            )}
          </Card>
          <TextField
            value={company.companyId}
            disabled={company._id ? true : false}
            floatingLabelText="Company Id"
            style={{ width: "22rem", marginTop: "20px" }}
            onChange={(e) => this.onChangeValue("companyId", e.target.value)}
            errorText={this.state.companyIdErrorText}
          />
          <TextField
            value={company.company}
            floatingLabelText="Company Name"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) => this.onChangeValue("company", e.target.value)}
            errorText={this.state.companyNameErrorText}
          />
          <TextField
            value={company.contactNumber}
            floatingLabelText="Contact Number"
            type="phone"
            style={{ width: "22rem", marginLeft: "20px" }}
            onChange={(e) =>
              this.onChangeValue("contactNumber", e.target.value)
            }
          />
          <br />
          <PlacesAutocomplete
            value={company.address ? company.address : ""}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <div
                style={{
                  width: "97.5%",
                  borderRadius: "0px",
                  marginTop: "2rem",
                }}
              >
                <input
                  {...getInputProps({
                    placeholder: "Search Address ...",
                    className: "location-search-input",
                    endAdornment: (
                      <IconButton>
                        <searchIcon />
                      </IconButton>
                    ),
                  })}
                  className="addressField"
                  ref="address"
                />
                <div className="autocomplete-dropdown-container">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion) => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item";
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? { backgroundColor: "#fafafa", cursor: "pointer" }
                      : { backgroundColor: "#ffffff", cursor: "pointer" };
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </PlacesAutocomplete>
          <br />
          <div style={{ float: "right" }}>
            <FlatButton
              className="c-btn__secondary"
              type="cancel"
              onTouchTap={this.closeCompanyModal}
            >
              Close
            </FlatButton>
            {company._id != "" ? (
              <FlatButton type="submit" onTouchTap={this.updateCompany}>
                Update
              </FlatButton>
            ) : (
              <FlatButton type="submit" onTouchTap={this.addCompany}>
                Add
              </FlatButton>
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Payroll/AddPayrollCompany.js